import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Context } from 'src/app/shared/models/context';
import { Company, EmployeeData, EmployeeProfileData } from 'src/app/shared/models/domain';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ProfileService } from 'src/app/shared/services/profile.service';


@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnInit {
  public activeTab = 'myAccount';
  public context!: Context;
  public employee!: EmployeeProfileData;
  public company!: Company;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private profileService: ProfileService,
    private cdr: ChangeDetectorRef,
    private dataService: AuthService
  ) { }

  ngOnInit(): void {
    this.context = {} as Context;
    this.context = this.dataService.getContextData();
    this.employee = { employeeData: {}, userData: {}, medium:[] } as EmployeeProfileData;
    this.route.queryParams.subscribe(params => {
      if (params['type']) {
        this.activeTab = params['type'];
      }
    });
    if(this.context.persona === 'CLIENT'){
      this.getCompanyProfileInfo();
    } else {
      this.getEmployeeProfileInfo();
    }
    if(this.context.persona==='ADMIN'){
      this.activeTab='change-password'
    }
  }

  public getEmployeeProfileInfo() {
    this.profileService.getEmployeeProfile().subscribe(profile => {
      this.employee = profile;
      this.cdr.detectChanges();
    });
  }

  public getCompanyProfileInfo() {
    this.profileService.getCompanyProfile().subscribe(profile => {
      this.company = profile;
      this.cdr.detectChanges();
    });
  }
  
  public setActiveTab(tab: string) {
    this.activeTab = tab;
    this.setRouteState(this.activeTab);
  }

  private setRouteState(queryParams: string) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { type: queryParams },
    });
  }
}